import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const OrderSuccess = () => {

    
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">

      <div className="bg-white shadow-lg rounded-xl p-10 max-w-lg w-full text-center">

        <div className="flex justify-center mb-6">
          <CheckCircle size={80} className="text-green-500" />
        </div>

        <h1 className="text-3xl font-bold mb-4">
          Order Placed Successfully!
        </h1>

        <p className="text-gray-600 mb-6">
          Thank you for shopping with us.  
          Your order is being processed and will be shipped soon.
        </p>

        <div className="flex gap-4 justify-center">

          <Link
            to="/account/orders"
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded transition"
          >
            View My Orders
          </Link>

          <Link
            to="/"
            className="border border-gray-400 px-6 py-2 rounded hover:bg-gray-100 transition"
          >
            Continue Shopping
          </Link>

        </div>

      </div>

    </div>
  );
};

export default OrderSuccess;